import React from "react";
import Layout from "../components/Layout";
import "../../src/style.css";

const PrivacyPolicy = () => {
  return (
    <Layout>
      <div className="privacy_policy">
        <div className="container">
          <h1 className="text-center">Privacy Policy</h1>
          <p>
            AZZIR ("AZZIR LLP","we","our") is committed to ensuring that your
            privacy is protected. This Privacy Policy explains how we use the
            information we collect about you (or that you provide us with), how
            you can instruct us if you prefer to limit the use of that
            information and procedures that we have in place to safeguard your
            privacy. For the purposes of this policy, the term “Curator” is used
            to refer to event creators using our SaaS solution to create and
            promote events. The term “Customers” shall be used to refer to an
            individual who attends, or consumes information in relation to, an
            event. Curators, Customers and other third parties who use our
            services are referred to in this policy as “Users”, “you” or “your”.
          </p>
          <p>
            We provide an SaaS solution that Event Curators may use to market to
            or stay in contact with Users and Customers while maximising their
            conversions via links. We provide a website and mobile application
            where individuals can buy tickets to events put on by the Curators
            who use our platform to sell tickets to their events. Curators may
            also partner with other Curators on the AZZIR platform to co-promote
            events.
          </p>
          <p>
            <i>AZZIR as a Data Controller and a Data Processor</i>
          </p>
          <p>
            Under our terms and conditions and this Privacy Policy, we may act
            as either a Data Controller or a Data Processor in respect of your
            Personal Data, depending on the applicable circumstances.{" "}
          </p>
          <p>
            Where you create an account with us to organise your events (i.e.
            you are acting as a Curator) or to explore the services we offer,
            AZZIR will be a Data Controller in respect of the Personal Data that
            you provide as part of our account. We will also be a Data
            Controller of the Personal Data that we have obtained about the use
            of our applications or platform, which could relate to any User.{" "}
          </p>
          <p>
            If you register for an event as a Customer, we will process your
            Personal Data to help administer that event on behalf of the Curator
            (for example processing payments, sending confirmation and
            promotional communications) and to help the Curator in the promotion
            of their Event. Alternatively, where you are a user of a Curator and
            the Curator imports your contact information into our Server as they
            wish to invite you to an Event or to use our platform, we will
            process your Personal Data to administer the Curator’s event or the
            Curator’s request In such circumstances, AZZIR provides the systems
            for Curators but does not control the Personal Data that is
            requested from an individual nor are we responsible for the
            continued accuracy of this Personal Data.{" "}
          </p>
          <p>
            Any questions you may have in this set of circumstances regarding
            the use of your data should be directed at the Curator. Where you no
            longer wish to be contacted by a Curator through our platform, you
            can unsubscribe from any communications you receive from AZZIR as
            set out above (see “You have the right to object to direct
            marketing”). In addition, in these circumstances, where you wish to
            update any inaccuracies in your Personal Data on our system, or wish
            for your Personal Data to be deleted from our system, you can
            contact either us or the Curator (see “You have the right to correct
            any inaccurate or incomplete Personal Data” and “You have the right
            to be forgotten” above). Please note that links from our website may
            take you to external websites not covered by this policy. We
            recommend that you check their privacy policies yourself before
            submitting any personal information. We will not be responsible for
            the content, function or information collection policies of these
            external websites.{" "}
          </p>

          <p>
            <ol>
              <li>
                The information we collect and how we collect it
                <p>
                  You are not required (by law or by any contract with us) to
                  provide personal information to us via this website. We will
                  only require you to provide personal information to us where
                  it is necessary for us to provide you with a service (such as
                  where you create an account with us).{" "}
                </p>
                <p>Information about all users</p>
                <p>
                  <i>Information we collect about you</i>
                </p>
                <p>
                  We may receive personal information about you whenever you
                  contact or engage with us. For example, by doing the
                  following:{" "}
                </p>
                <p>
                  <ul>
                    <li>
                      creating and using a registered account on our website
                    </li>
                    <li>
                      creating an account, or accessing our website/platform
                      using a third party account (for example a social media
                      account){" "}
                    </li>
                    <li>using and browsing our website</li>
                    <li>
                      telephoning, texting, writing by post or emailing us
                    </li>
                  </ul>
                </p>
                <p>This information may include the following: </p>
                <p>
                  <ul>
                    <li>
                      normal identification information, such as your full name,
                      date of birth, age, gender, marital status;{" "}
                    </li>
                    <li>
                      contact information, such as your postal address, email
                      address and telephone number;{" "}
                    </li>
                    <li>
                      social media identification information, such your
                      Facebook page address, your Twitter handle, your Instagram
                      handle and profile picture;{" "}
                    </li>
                    <li>
                      additional information relevant to your use of our site
                      and services, or your event or services, such as your
                      marketing preferences, survey responses and feedback
                    </li>
                  </ul>
                </p>
                <p>
                  Please note that AZZIR will not store credit or debit card
                  information from payments made through our services other than
                  where it is necessary for us to complete our obligations to
                  you.
                </p>
                <p>
                  In addition, we also automatically collect certain technical
                  data that is sent to us from the computer, mobile device
                  and/or browser through which you access the Services. You can
                  find out more information about this information we collect in
                  section 4 below.{" "}
                </p>
                <p>
                  <i>Information we collect from other sources</i>
                </p>
                <p>
                  We may collect information about you from other sources. This
                  may include for example information you have shared publicly,
                  including on social media.{" "}
                </p>
                <p>
                  In addition, you can also create your AZZIR account using, or
                  connect your AZZIR account to, your accounts on third party
                  services such as Facebook, Twitter or Instagram. In the event
                  that this occurs, we may collect, use, disclose, transfer and
                  store/retain information relating to your account with such
                  third party services in accordance with this Privacy Policy.{" "}
                </p>
                <p>
                  <i>Information we receive from other sources</i>
                </p>
                <p>
                  Sometimes you will have given your consent for other websites,
                  services or third parties to provide information to us.{" "}
                </p>
                <p>
                  For example, this could include information we receive about
                  you if you follow a Curator’s page/website we operate or any
                  other services we provide, in which case we will have informed
                  you when we collected this data that it may be shared. We will
                  also have told you for what purpose we will share your data.{" "}
                </p>
                <p>
                  It could also include information from third parties that we
                  work with to provide our products and services, such as
                  payment processors, delivery companies, technical support
                  companies and advertising companies. Whenever we receive
                  information about you from these third parties, we will let
                  you know what information we have received and how and why we
                  intend to use it.{" "}
                </p>
                <p>Information about Curators</p>
                <p>
                  <i>Information we collect about you</i>
                </p>
                <p>
                  In addition to what is set out above, where you are a Curator
                  then we may collect additional information about you.{" "}
                </p>
                <p>
                  For example, where you use our payment processing services we
                  will collect financial information from you (for example your
                  bank account details and address) as necessary to facilitate
                  payments received for your events. In addition, we may collect
                  any information which is required for tax purposes.{" "}
                </p>
                <p>
                  <i>Information we receive from other sources</i>
                </p>
                <p>
                  Along with the information set out above, we may also collect
                  or receive Personal Data from third party sources, such as
                  other websites, your bank, our payment processing partners and
                  our credit reference agencies.{" "}
                </p>
                <p>Information from Curators</p>
                <p>
                  Where you are a Curator and you use our services and platform,
                  you may import into our system Personal Data you have
                  collected from your customers. We have no direct relationship
                  with these individuals or any person other than you and for
                  that reason, as is set out in the terms and conditions of our
                  website, you are responsible for making sure you have the
                  appropriate permission for us to collect and process
                  information about those individuals.{" "}
                </p>
                <p>Information about Customers</p>
                <p>
                  <i>Information we collect about you</i>
                </p>
                <p>
                  As a Customer we will collect additional Personal Data from
                  you, sometimes for our own purposes and other times on behalf
                  of a Curator.{" "}
                </p>
                <p>
                  If you register for a paid event, you will provide financial
                  information (e.g. your credit card number and expiration date,
                  billing address etc.), some of which may constitute Personal
                  Data. Please note that as set out above, AZZIR will not store
                  this credit card information for as long as is necessary to
                  complete our obligations towards a Customer.{" "}
                </p>
                <p>
                  Also, Curators can create event registration pages to collect
                  information from Customers regarding their registration for a
                  Curator’s event listed on our Services. AZZIR does not control
                  the Curator’s registration process nor any Personal Data that
                  a Curator collects. Personal Data collected on behalf of
                  Curators is provided to the Curator of the applicable event in
                  accordance with the provisions set out below.{" "}
                </p>
              </li>
              <li>
                How do we use the personal information we collect?
                <p>
                  We do not sell/trade your data to other curators or
                  third-parties. We strongly believe that your data should be in
                  your hand. We take data protection seriously, so below we have
                  set out exactly how and why we use your information, and what
                  our legal basis is to be able to use your information in each
                  way.{" "}
                </p>
                <p>
                  We need all the categories of information listed above to
                  allow us to enter into and perform our contract with you*, to
                  enable us to comply with legal obligations⁑, and in order to
                  pursue legitimate interests of our own or those of third
                  parties⁂ (provided your interests and fundamental rights do
                  not override those interests). The situations in which we will
                  process your Personal Data are listed below. We have indicated
                  by asterisks the purpose or purposes for which we are
                  processing or will process your personal information.{" "}
                </p>
                <p>
                  <ul>
                    <li>Verifying your identity (*, ⁑, ⁂)</li>
                    <li>
                      To enable you to access the services we provide (*, ⁂)
                    </li>
                    <li>
                      To enable you to create an account on our website/platform
                      (*, ⁂)
                    </li>
                    <li>
                      Making a decision and processing a ticket purchase. (*)
                    </li>
                    <li>Determining the terms of a ticket purchase. (*)</li>
                    <li>
                      Administering any agreement we have entered into with you.
                      (*)
                    </li>
                    <li>
                      Administering any agreement you have entered into with
                      another party on our platform (*)
                    </li>
                    <li>
                      Administering our payment processing services, including
                      the receipt of payments from Customers and the making of
                      payments to Curators or other Users (*, ⁂)
                    </li>
                    <li>
                      To contact you about any events or other offers you have
                      expressed an interest in (⁂)
                    </li>
                    <li>
                      To contact you in the event of an issue with your use of
                      our site (*, ⁂)
                    </li>
                    <li>Dealing with any complaints you may have (*, ⁂)</li>
                    <li>
                      Business management and planning, including accounting and
                      auditing. (⁑, ⁂)
                    </li>
                    <li>
                      Conducting performance reviews, managing performance and
                      determining performance requirements. (⁂)
                    </li>
                    <li>
                      Complying with health and safety obligations. (⁑, ⁂)
                    </li>
                    <li>Complying with our tax obligations (⁑, ⁂)</li>
                    <li>
                      To detect and prevent fraud, money-laundering and other
                      crimes. (⁑)
                    </li>
                    <li>
                      To monitor your use of our systems to ensure compliance
                      with our IT policies. (⁂)
                    </li>
                    <li>
                      To ensure our systems interact successfully with social
                      media platforms including Facebook, Twitter and Instagram
                      (⁂)
                    </li>
                    <li>
                      To ensure network and information security, including
                      preventing unauthorised access to our computer and
                      electronic communications systems and preventing malicious
                      software distribution. (⁂)
                    </li>
                    <li>
                      To conduct data analytics studies to review and better
                      understand users use of your website and services (⁂)
                    </li>
                    <li>
                      To review and improve the performance of our website,
                      systems, processes and staff. (⁂)
                    </li>
                    <li>
                      To interact and respond to any communications you send us,
                      including social media posts that you tag us in. (⁂)
                    </li>
                    <li>
                      To let you know about any important changes to our
                      business or policies. (⁂)
                    </li>
                    <li>
                      To protect your interests, or the interests of others
                      (such as in the event of criminality such as identity
                      theft, piracy or fraud). (⁑, ⁂)
                    </li>
                  </ul>
                </p>
                <p>
                  <i>Providing our services</i>
                </p>
                <p>
                  It is necessary for us to use personal information about you
                  to enter into and perform the contracts that we make with you,
                  such as when you are purchasing a ticket using our website
                  with us, you establish yourself as a Curator on our site or
                  you create your own website using our services. Using your
                  information in this context is necessary so that we can:{" "}
                </p>
                <p>
                  <ul>
                    <li>
                      provide you with information about your event/an event you
                      are attending and any other of our services
                    </li>
                    <li>verify your identity</li>
                    <li>deal with any complaints you may have</li>
                    <li>
                      contact you about any changes to your event/an event you
                      are attending or that we make to our products or services
                    </li>
                    <li>
                      administer our website, including troubleshooting
                      problems, analysing statistics, conducting research and
                      tests and keeping the site secure
                    </li>
                    <li>
                      where you are a Curator or otherwise advertising an event:
                      <ul>
                        <li>
                          provide you with information on the attendees at your
                          event
                        </li>
                        <li>
                          ensure you receive payments owed to you in relation to
                          an event
                        </li>
                        <li>
                          contacting you to bill and collect any money owed to
                          us
                        </li>
                        <li>
                          syncing your social media account or page with your
                          AZZIR account to inform you of other services we offer
                        </li>
                      </ul>
                    </li>
                  </ul>
                </p>
                <p>
                  <i>Making our business better</i>
                </p>
                <p>
                  We always want to offer the best products, services and
                  experience that we can. Sometimes this means we may use your
                  information to find ways that we can improve what we do, or
                  how we do it.{" "}
                </p>
                <p>
                  In this context, we will only use your information where it is
                  necessary so that we can:{" "}
                </p>
                <p>
                  <ul>
                    <li>
                      review and improve our existing products and services and
                      develop new ones;{" "}
                    </li>
                    <li>
                      review and improve the performance of our systems,
                      processes and staff (including training);{" "}
                    </li>
                    <li>
                      improve our site to ensure that content is presented in
                      the most effective manner for you and for your computer;
                      and
                    </li>
                    <li>
                      measure and understand the effectiveness of advertising we
                      serve to you and others, and to deliver relevant
                      advertising to you.{" "}
                    </li>
                  </ul>
                </p>
                <p>Contacting you</p>
                <p>
                  Sometimes we may need to use the information that we have
                  about you in order to respond to your questions or let you
                  know about important changes.{" "}
                </p>
                <p>
                  We will only use your information in this respect where it is
                  necessary so that we can:{" "}
                </p>
                <p>
                  <ul>
                    <li>
                      {" "}
                      interact and respond to any communications you send us,
                      including where you use our contact us form and any social
                      media posts that you tag us in
                    </li>
                    <li>
                      {" "}
                      let you know about any important changes to our business
                      or policies
                    </li>
                  </ul>
                </p>
                <p>
                  We do not broadcast information across any messaging platform
                  about events, curators or anything that might not relate to
                  any update in our business and update to events you may have
                  bought tickets to.
                </p>
                <p>
                  Such messages maybe fraudulent please report such incident
                  with us on AZZIR@gmail.com
                </p>
                <p>
                  <i>Verifying your identity</i>
                </p>
                <p>
                  We may use your information where it is necessary for us to do
                  so in order to send OTP to login, to meet our legal
                  obligations or to detect and prevent fraud, money-laundering
                  and other crimes.{" "}
                </p>
                <p>
                  <i>Protecting you and others from harm</i>
                </p>
                <p>
                  We may use your information where it is necessary to protect
                  your interests, or the interests of others. This may include
                  in the event of criminality such as identity theft, piracy or
                  fraud.{" "}
                </p>
              </li>
              <li>
                Who do we share your personal information with?
                <p>Sharing your information within our company</p>
                <p>
                  We share the information that you provide to us with our staff
                  so that we can provide our products and services to you.{" "}
                </p>
                <p>Sharing your information with third parties</p>
                <p>
                  Curators are allowed to use our system to contact Customers of
                  their current and past events, so you may receive emails from
                  our system that originate from such Curators that we send on
                  their behalf. If a Customer registered for an event using our
                  platform, their email address is available to the Curator of
                  that event.{" "}
                </p>
                <p>
                  Curators may also import contact information they have from
                  external sources and send communications through our platform
                  to those individuals, we and will deliver those communications
                  to those individuals on the Curator’s behalf. The Curator and
                  not AZZIR is responsible for sending these communications. The
                  Customer has the right to opt out of such communications at
                  any time, as is set out below.{" "}
                </p>
                <p>
                  Curators may also partner with other Curators on the AZZIR
                  platform to Co-Promote events whereby they recommend similar
                  events by other Curators to their Customers.{" "}
                </p>
                <p>
                  In addition to the above, there are certain exceptional
                  circumstances in which we may disclose your information to
                  third parties. This would be where we believe that the
                  disclosure is:{" "}
                </p>
                <p>
                  <ul>
                    <li>
                      required by the law, or in order to comply with judicial
                      proceedings, court orders or legal or regulatory
                      proceedings;{" "}
                    </li>
                    <li>
                      necessary to protect the safety of our employees, our
                      property or the public;{" "}
                    </li>
                    <li>
                      necessary for the prevention or detection of crime,
                      including exchanging information with other companies or
                      organisations for the purposes of fraud protection and
                      credit risk reduction; and
                    </li>
                    <li>
                      Sometimes, we share your information with our third-party
                      providers, who help us provide and support our Services.
                      Examples of third-party providers include payment
                      processors and hosting services. We have contracts with
                      each of these providers that specify that they will only
                      use your data for the purposes of performing the services
                      we have contracted them for. Anonymised data is also used
                      for the purposes of website and app analytics.{" "}
                    </li>
                  </ul>
                </p>
              </li>
              <li>
                Where we store your Personal Data
                <p>
                  {" "}
                  The data that we collect from you may be transferred to, and
                  stored at, a destination outside India. It may also be
                  processed by staff operating outside India who work for us or
                  for one of our suppliers. Such staff may be engaged in, among
                  other things, the fulfilment of your order, the processing of
                  your payment details and the provision of support services. By
                  submitting your Personal Data, you agree to this transfer,
                  storing or processing. AZZIR will take all steps reasonably
                  necessary to ensure that your data is treated securely and in
                  accordance with this Privacy Policy, our terms of use and the
                  applicable data protection legislation
                </p>
                <p>
                  {" "}
                  All information you provide to us is stored on our secure
                  servers. Any payment transactions will be encrypted (using SSL
                  technology). Where we have given you (or where you have
                  chosen) a password which enables you to access certain parts
                  of our site, you are responsible for keeping this password
                  confidential. We ask you not to share a password with anyone.{" "}
                </p>
                <p>
                  {" "}
                  Unfortunately, the transmission of information via the
                  internet is not completely secure. Although we will do our
                  best to protect your Personal Data, we cannot guarantee the
                  security of your data transmitted to our site; any
                  transmission is at your own risk. Once we have received your
                  information, we will use strict procedures and security
                  features to try to prevent unauthorised access.{" "}
                </p>
                <p>
                  {" "}
                  In addition, where you are a Curator and import your database
                  of personal information into our system, your database is
                  stored on our secure servers. We do not, under any
                  circumstances, sell or give access to your database. If an
                  individual whose information is on your database complains or
                  contacts us, we might then contact that person.{" "}
                </p>
                <p>
                  {" "}
                  Please note, if we detect abusive or illegal behaviour related
                  to your database, we may share your database or portions of it
                  with affected ISPs or anti-spam organisations.{" "}
                </p>
              </li>
              <li>
                Notice of Security Breach where AZZIR is a Data Processor
                <p>
                  {" "}
                  Where a security breach causes an unauthorised instruction
                  into our system that materially affects data which AZZIR holds
                  in its role as a Data Processor for a Curator (see below),
                  then AZZIR will notify the Curator as soon as possible and
                  later report the action we took in response. Under the terms
                  of the GDPR and any and all domestic legislation incorporating
                  the Regulation into English law, we will also inform the ICO
                  within 72 hours of any breach.{" "}
                </p>
              </li>
              <li>
                Disclosure of your information
                <p>
                  {" "}
                  We may disclose your personal information to third parties:{" "}
                </p>
                <p>
                  <ul>
                    <li>
                      If we are under a duty to disclose or share your Personal
                      Data in order to comply with any legal obligation, or in
                      order to enforce or apply our terms of use and other
                      agreements; or to protect the rights, property, or safety
                      of AZZIR, our customers, or others. This includes
                      exchanging information with other companies and
                      organisations for the purposes of fraud protection and
                      credit risk reduction.{" "}
                    </li>
                  </ul>
                </p>
              </li>
              <li>
                Updating your details
                <p>
                  All personal information entered into AZZIR can be edited and
                  changed by you at any time. Alterations can be made in the
                  settings area.{" "}
                </p>
              </li>
              <li>
                Your rights
                <p>
                  <i>You have the right to cancel your membership</i>{" "}
                </p>
                <p>
                  You have the right to cancel your membership at any time. This
                  can be done by contacting AZZIR@gmail.com
                </p>
                <p>
                  <i>You have the right to be informed</i>{" "}
                </p>
                <p>
                  We have a legal obligation to provide you with concise,
                  transparent, intelligible and easily accessible information
                  about your personal information and our use of it. We have
                  written this policy to do just that, but if you have any
                  questions or require more specific information, you can get in
                  touch with us.{" "}
                </p>
                <p>
                  <i>You have the right to access your Personal Data</i>{" "}
                </p>
                <p>
                  You have the right to ask us to confirm whether or not we hold
                  any of your personal information. If we do, you have the right
                  to have a copy of your information and to be informed of the
                  following:{" "}
                </p>
                <p>
                  <ul>
                    <li>why we have been using your information; </li>
                    <li>what categories of information we were using; </li>
                    <li>who we have shared the information with; and</li>
                    <li>how long we envisage holding your information</li>
                  </ul>
                </p>
                <p>
                  {" "}
                  In order to maintain the security of your information, we will
                  have to verify your identity before we provide you with a copy
                  of the information we hold.{" "}
                </p>
                <p>
                  {" "}
                  The first copy of your information that you request from us
                  will be provided free of charge, if you require further copies
                  we may charge an administrative fee to cover our costs.{" "}
                </p>
                <p>
                  {" "}
                  <i>
                    {" "}
                    You have the right to correct any inaccurate or incomplete
                    Personal Data
                  </i>{" "}
                </p>
                <p>
                  {" "}
                  Where you have requested a copy of the information we hold
                  about you, you may notice that there are inaccuracies in the
                  records, or that certain parts are incomplete. If this is the
                  case you can update your information by contacting
                  AZZIR@gmail.com so that we can correct our records.{" "}
                </p>
                <p>
                  {" "}
                  Where your Personal Data is imported into our server by a
                  Curator, you may also wish to contact that Curator in order
                  for them to correct any inaccuracies in their records.{" "}
                </p>
                <p>
                  {" "}
                  <i> You have the right to be forgotten</i>{" "}
                </p>
                <p>
                  {" "}
                  There may be times where it is no longer necessary for us to
                  hold personal information about you. This could be if:{" "}
                </p>
                <p>
                  <ul>
                    <li>
                      the information is no longer needed for the original
                      purpose that we collected it for
                    </li>
                    <li>
                      you withdraw your consent for us to use the information
                      (and we have no other legal reason to keep using it){" "}
                    </li>
                    <li>
                      you object to us using your information and we have no
                      overriding reason to keep using it
                    </li>
                    <li>we have used your information unlawfully</li>
                    <li>
                      we are subject to a legal requirement to delete your
                      information
                    </li>
                  </ul>
                </p>
                <p>
                  {" "}
                  In those situations you have the right to have your Personal
                  Data deleted. If you believe one of these situations applies
                  to you, please get in touch with us. Where you submit a
                  request for us to delete your Personal Data, we will remove
                  your data from our systems within a reasonable time.{" "}
                </p>
                <p>
                  {" "}
                  In addition, where a Curator is the Data Controller in
                  relation to Personal Data which you wish for us to delete from
                  our systems, we will also notify the Curator of your request.
                  Where this applies, you may also request the deletion of your
                  Personal Data by contacting the Curator.{" "}
                </p>
                <p>
                  {" "}
                  <i>
                    {" "}
                    You have the right to have a copy of your data transferred
                    to you or a third party in a compatible format
                  </i>{" "}
                </p>
                <p>
                  {" "}
                  Also known as Data Portability, you have the right to obtain a
                  copy of your Personal Data for your own purposes. This right
                  allows you to move, copy or transfer your Personal Data more
                  easily from one IT system to another, in a safe and secure
                  way.{" "}
                </p>
                <p> This right shall only apply where: </p>
                <p>
                  <ul>
                    <li>
                      we are processing your information for the purposes of
                      entering into or performing a contract; or
                    </li>
                    <li>
                      you have provided consent for us to process your
                      information.{" "}
                    </li>
                  </ul>
                </p>
                <p>
                  If you would like us to transfer a copy of your data to you or
                  another organisation in a structured, commonly use and
                  machine-readable format, please contact us. There is no charge
                  for you exercising this right.{" "}
                </p>
                <p>
                  We aim to always ensure that your rights and information are
                  properly protected. If you believe that the way we are using
                  your data is not justified due to its impact on you or your
                  rights, you have the right to object. Unless we have a
                  compelling reason to continue, we must stop using your
                  Personal Data for these purposes.{" "}
                </p>
                <p>
                  <i>
                    You have the right to restrict how we use your Personal Data
                  </i>{" "}
                </p>
                <p>
                  You have the right to ask us to stop using your Personal Data
                  in any way other than simply keeping a copy of it. This right
                  is available where:{" "}
                </p>
                <p>
                  <ul>
                    <li>
                      you have informed us that the information we hold about
                      you is inaccurate, and we have not yet been able to verify
                      this;{" "}
                    </li>
                    <li>
                      you have objected to us using your information for our own
                      legitimate interests and we are in the process of
                      considering your objection;{" "}
                    </li>
                    <li>
                      we have used your information in an unlawful way, but you
                      do not want us to delete your data; or
                    </li>
                    <li>
                      we no longer need to use the information, but you need it
                      for a legal claim.{" "}
                    </li>
                  </ul>
                </p>
                <p>
                  If you believe any of these situations apply, please contact
                  us at AZZIR@gmail.com
                </p>
                <p>
                  <i>
                    You have rights related to automated-decision making and
                    profiling
                  </i>{" "}
                </p>
                <p>
                  Any automated decision-making or profiling we undertake is
                  solely for the purpose of tailoring the information which we
                  provide to you. We will not use automated decision-making or
                  profiling to make any decisions which will have a legal effect
                  upon you or otherwise significantly affect you, and you have
                  the right not to be subject to such decisions. If you have any
                  concerns or questions about this right, please contact us at
                  AZZIR@gmail.com.{" "}
                </p>
              </li>
              <li>
                Changes to this Privacy Policy
                <p>
                  If we change our Privacy Policy we will post the changes on
                  this page, and may place notices on other pages of the
                  website, so that you may be aware of the information we
                  collect and how we use it at all times. We will also contact
                  you to inform you that changes have been made to this policy.
                  Regularly reviewing this page will ensure that you are always
                  aware of what information we collect and how we use it.
                  Continued use of the service will signify that you agree to
                  any such changes.{" "}
                </p>
              </li>
              <li>
                Contacting AZZIR and making a complaint
                <p>
                  We welcome your views about our website and our Privacy
                  Policy. If you would like to contact us with any queries or
                  comments, or to complain about our collection or use of your
                  Personal Data, please contact AZZIR@gmail.com{" "}
                </p>{" "}
              </li>
            </ol>
          </p>
        </div>
      </div>
      <a href="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </a>
    </Layout>
  );
};

export default PrivacyPolicy;
